// Registry of bundled translation catalogs, keyed by the catalog codes the
// server's LocaleResolver produces (12 languages + regional variants, matching
// the native app). Catalogs are imported (bundled), so they're present in both
// the SSR and client bundles. Key parity across all catalogs is enforced by
// scripts/check-locale-keys.mjs (yarn check:locales).
import da from './da'
import de from './de'
import en from './en'
import enGB from './en-GB'
import es from './es'
import esES from './es-ES'
import es419 from './es-419'
import fr from './fr'
import it from './it'
import ja from './ja'
import ko from './ko'
import nl from './nl'
import nb from './nb'
import pt from './pt'
import ptBR from './pt-BR'
import ptPT from './pt-PT'
import zhHans from './zh-Hans'
import zhHant from './zh-Hant'

export const CATALOGS = {
  da,
  de,
  en,
  'en-GB': enGB,
  es,
  'es-ES': esES,
  'es-419': es419,
  fr,
  it,
  ja,
  ko,
  nl,
  nb,
  pt,
  'pt-BR': ptBR,
  'pt-PT': ptPT,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
}

// Map a locale code to the best available catalog. The server already resolves
// Accept-Language to a supported code, so this is mainly a safety net: try the
// exact code, then its base language, then English.
export function resolveCatalog(locale) {
  if (CATALOGS[locale]) return locale
  const base = String(locale || '').split('-')[0]
  if (CATALOGS[base]) return base
  return 'en'
}
